<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <v-card>
      <v-card-title class="text-h5">
        Modify Terminal
      </v-card-title>

      <v-card-text>
        <strong>Terminal Hash: </strong>{{terminal.terminalId}} <br>
        <strong>Terminal Public ID: </strong>{{terminal.publicId}} <br>
        Delete or Edit Terminal
        <br>
        <v-chip x-small color="error">ALL CHANGES ARE IMMEADIATE</v-chip>
      </v-card-text>

      <v-card-actions>
        <v-btn
          color="warning"
          @click="closeDialog"
        >
          Close
        </v-btn>
        <v-spacer></v-spacer>

        <v-btn
          color="warning"
          disabled
          @click="this.$emit('close')"
        >
          Edit
        </v-btn>

        <v-btn
          color="error"
          @click="deleteTerm(terminal.terminalId)"
        >
          Delete Terminal
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      dialogTerminal: this.dialog
    }
  },
  props: {
    dialog: Boolean,
    terminal: Object
  },
  methods: {
    ...mapActions('terminalStore',['fetchRegisteredTerminals', 'deregisterTerminal']),
    closeDialog () {
      this.$emit('close')
    },
    deleteTerm (v) {
      this.deregisterTerminal(v)
      this.$emit('close')
    }
  }
}
</script>

<style>

</style>